// extracted by mini-css-extract-plugin
export default {"pageShell":"GrantAccess_pageShell__P-uAa"};